import { render, staticRenderFns } from "./LessonEvidence.vue?vue&type=template&id=4ec6e6c0&scoped=true&"
import script from "./LessonEvidence.vue?vue&type=script&lang=js&"
export * from "./LessonEvidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec6e6c0",
  null
  
)

export default component.exports